export default {
  fields: {
    online_shop_domain: 'Own domain for the online shop',
    online_shop_domain_hint:
      'A domain the restaurant owns, such as order.pizzeria-mario.com — for ordering only; a website needs a different one. Once saved, the records to add are shown here.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
